export interface Tab {
  id: string;
  label: string;
  href: string;
  hidden?: boolean;
}

export function createTabBar(tabs: Tab[], activeId: string, onNavigate: (href: string) => void): HTMLElement {
  const nav = document.createElement('nav');
  nav.className = 'tab-bar';
  nav.setAttribute('role', 'tablist');

  for (const tab of tabs) {
    if (tab.hidden) continue;

    const a = document.createElement('a');
    a.className = `tab${tab.id === activeId ? ' tab--active' : ''}`;
    a.href = tab.href;
    a.textContent = tab.label;
    a.setAttribute('role', 'tab');
    a.setAttribute('aria-selected', String(tab.id === activeId));
    
    a.addEventListener('click', (e) => {
      e.preventDefault();
      onNavigate(tab.href);
    });

    nav.appendChild(a);
  }

  return nav;
}
